module.exports = __webpack_public_path__ + "static/media/fsociety.81f1089f.PNG";